/**
 *  The directive allows use any Vue modern UI component inside legacy environment
 *
 * 	<div v-shadow-root>
 *		<ModernVueComponent />
 *	</div>
 *
 *  also we can send a props to directive
 *  4ex: v-shadow-root = { css: ['http://public/custom.css'] }
 *  if props not passed it apply defaultStylesheetsURLs from CSSBundler settings
 **/

import Vue, { ObjectDirective } from 'vue';

import cssBundlerModule from '@/HostApp/services/CSSBundler/CSSBundlerModule';
import spriteBundlerModule from '@/HostApp/services/CSSBundler/SpriteBundlerModule';

const shadowRootDirective: ObjectDirective = {
	inserted: async (el: HTMLElement, binding) => {
		if (!binding.hasOwnProperty('value') || binding.value) {
			const { visibility } = el.style;
			el.style.visibility = 'hidden';

			const shadowRoot = el.attachShadow({ mode: 'open' });
			const cssBundles = binding.value?.css;

			if (el.firstElementChild) {
				const svgSpriteBundler = spriteBundlerModule.attachSprite(el.shadowRoot);
				const cssBundler = cssBundlerModule.applyCSSBundles(el.shadowRoot, cssBundles);

				await Promise.all([cssBundler, svgSpriteBundler]);

				shadowRoot.append(el.firstElementChild);
			}

			await Vue.nextTick();
			el.style.visibility = visibility;
		}
	}
};

export default shadowRootDirective;
